// MyVerticallyCenteredModal.tsx
import React from 'react';
import { Modal } from 'react-bootstrap';
import Accordion from '../Accrodion/Accordion';
import styles from './Modal.module.css'
import { DefaultButton } from '@fluentui/react';

interface MyModalProps {
  show: boolean;
  onHide: () => void;
  items: any[]; // ideally type this properly
}

const VerticallyCenteredModal: React.FC<MyModalProps> = ({ show, onHide, items }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Data Sources
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modal_body}>
        <Accordion items={items} />
      </Modal.Body>
      <Modal.Footer>
        <DefaultButton onClick={onHide} className={styles.feedbackBtn}>Close</DefaultButton>
      </Modal.Footer>
    </Modal>
  );
};

export default VerticallyCenteredModal;
